import { render, staticRenderFns } from "./ManageRolesPermission.vue?vue&type=template&id=dadc9a5c&scoped=true"
import script from "./ManageRolesPermission.vue?vue&type=script&lang=js"
export * from "./ManageRolesPermission.vue?vue&type=script&lang=js"
import style0 from "./ManageRolesPermission.vue?vue&type=style&index=0&id=dadc9a5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dadc9a5c",
  null
  
)

export default component.exports